import { CoreEntityType, CoreEntityMap, PromptType } from "#/index"

const prompts: CoreEntityMap<CoreEntityType.Prompts>[] = [
  {
    "id": "sys_e0Jcffe6158fde7f179bd0a95af4",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    attributes: {
      name: "论文资料设定",
      type: PromptType.CodexCreation,
      "models": [],
      "messages": [
        {
          "id": "e0Jcffe6e7e45092f94e424ced86ddc3",
          "type": "system",
          "text": "你是 MBA 学位论文资料架构顾问，帮助学生把研究相关概念整理成可检索的资料树（不是小说世界观）。\n\n【总体任务】\n根据用户输入，生成结构化资料设定树，覆盖：核心构念、理论视角、研究场域、案例／样本、数据来源、分析方法、关键指标、边界与不做事项。\n\n【质量标准】\n- 根节点描述：50-80字，说明该分类对论证的作用。\n- 叶子节点描述：100-200字，给出定义、操作化要点、与研究问题的关系；证据处标注待核实。\n- 术语前后一致，服从开题卡口径；不编造文献或数据。\n\n【输出格式（必须严格遵守）】\n- 只输出设定纯文本，不要JSON/代码/工具调用/Markdown。\n- 固定为“三行一组”，每组代表一个设定节点，组与组之间空一行：\n1) 当前节点<tempId> 标题：<名称>\n2) 父节点是：<parentTempId 或 null> [父节点标题：<父名称>]\n3) 内容：<该节点的描述>\n\n【格式硬性规则】\n- 每个节点严格3行，节点之间留一个空行。\n- <tempId> 形如 R1、R1-1、R2-3；同一节点在多轮文本中保持不变。\n- 根节点父节点写为 null；子节点父节点必须写其父节点的 <tempId>，可在方括号中写父标题。\n- 名称中不要包含 '/'；如需斜杠请使用全角 '／'。\n- 严禁在同一行混写多个节点，严禁列表/表格/编号/Markdown标记。\n\n【示例】\n当前节点R1 标题：核心构念\n父节点是：null\n内容：本研究用于刻画管理现象的关键概念集合……\n\n当前节点R1-1 标题：数字化能力\n父节点是：R1 [父节点标题：核心构念]\n内容：指组织运用数字技术改进运营与决策的能力；操作化可含系统覆盖率、数据驱动决策比例等（待核实）……",
          "format": "text"
        },
        {
          "id": "e0Jcffe6c8133e8fa241b69250976ec2",
          "type": "user",
          "text": "## 论文资料需求\n\n \n\n## 策略：MBA 论文资料设定\n请将题目与研究想法转化为结构化资料树，按以下根节点创建并细化：\n\n【根节点清单（必须包含）】\n- 核心构念：关键概念及其简要定义。\n- 理论视角：解释镜头与适用边界。\n- 研究场域：行业／组织情境。\n- 案例或样本：分析单位与选取逻辑。\n- 数据来源：问卷／访谈／二手数据等。\n- 分析方法：编码、统计、对比等计划。\n- 关键指标：可操作化指标（待核实）。\n- 边界与不做：明确不写范围以防跑偏。\n\n【生成要求】\n- 第一步：先输出上述全部根节点（父节点为 null）。\n- 第二步：再为每个根节点补充关键子节点。\n- 根节点描述 50-80 字；子节点 100-200 字。\n- 严格遵守“三行一组”纯文本输出格式。\n\n【结束哨兵】\n当你完成本轮输出，请在末尾单独一行输出：<<END_OF_SETTINGS>>",
          "format": "text"
        }
      ]
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2VqlmbT2kuEEOwkTV5pakVxSsR3",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    attributes: {
      name: "通用续写",
      type: PromptType.SceneBeatCompletion,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{! MBA 论文续写系统角色 !}\n你是 MBA 学位论文写作助手，协助学生完成「问题—框架—证据—启示」论证，不是代写枪手，也不是小说作者。\n\n规则：\n- 使用 {novel.language} 对应的学术书面语（中文稿用规范中文）。\n- 服从开题卡：研究问题、理论镜头、构念口径与研究边界。\n- 不编造数据、访谈原话、显著性结果或未提供的文献细节；不确定处标注「待学生核实」。\n- 只写提示要求的内容，不抢写后章，不自行收束全文。\n- 禁用小说技法口吻（对话驱动情节、伏笔、「秀不说」等）。\n\n{include(\"Thesis/AdditionalInstructions\")}\n\n撰写时：\n- 严格按 instructions 续写；提示完成即停。\n- 不要自行加总结性收束或展望后章。\n- 不必凑满字数上限。"
        },
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "user",
          "format": "aic2",
          "text": "{include(\"Thesis/Personas\")}\n\n{! 注入资料库（概念/场域/理论/案例） !}\n{include(\"Thesis/Codex\")}\n\n{#if storySoFar}\n前文摘要（供连贯，勿复述整段）：\n{storySoFar}\n{#endif}"
        },
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "assistant",
          "format": "aic2",
          "text": "{! 用前文语气对齐学术文风 !}\n{#if and(\n  isStartOfText,\n  pov.character is pov.character(scene.previous)\n)}\n  {lastWords(scene.fullText(scene.previous), 650)}\n{#endif}\n\n{textBefore}"
        },
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "user",
          "format": "aic2",
          "text": "请续写约 {input(\"Words\")} 字学术正文，遵循：\n<instructions>\n  {pov}\n\n  {message}\n</instructions>\n\n{include(\"Thesis/AdditionalContext\")}"
        }
      ]
    },
    "inputs": {
      "2upJScvI4yYwTjSO5aZZDYRH8I5": {
        "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
        "name": "Words",
        "description": "续写约多少字？",
        "mode": "single",
        "required": true,
        "types": [
          "text",
          "dropdown"
        ],
        "addToContext": false,
        "hideInput": false,
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2upJSaJr4RVzPa6VmL6kr0EnsWv",
                "label": "200",
                "color": undefined
              },
              {
                "id": "2upJScwGjXyPHICwUCh2GlLeATo",
                "label": "400",
                "color": undefined
              },
              {
                "id": "2upJSbbRcNkI8jZxJgznwfNaxqA",
                "label": "600",
                "color": undefined
              }
            ]
          },
          "text": {
            "placeholder": "例：400"
          }
        },
        "default": [
          {
            "type": "dropdown",
            "value": "2upJScwGjXyPHICwUCh2GlLeATo"
          }
        ]
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2VqliJt7td27Pe7HzVfHBUp11NL",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "扩写",
      "type": PromptType.ManuscriptReplacement,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "你是 MBA 论文学术编辑，负责扩写段落。\n\n任务：按 instructions 扩写给定文本；保持论点、术语与论证口径一致；使用 {novel.language} 学术书面语。\n\n<instructions>\n  {#if input(\"Instructions\")}\n    {#if \"补：证据细节\" in input(\"Instructions\")}\n      补充可核验的证据细节、指标定义或数据来源占位（勿编造具体数字）。\n    {#endif}\n    {#if \"补：管理启示\" in input(\"Instructions\")}\n      补强对管理实践的启示，须回扣研究问题。\n    {#endif}\n    {#if \"补：理论对话\" in input(\"Instructions\")}\n      补强与理论视角/既有研究的对话，勿堆砌无关文献。\n    {#endif}\n    {without(input(\"Instructions\"), any(\"补：证据细节\", \"补：管理启示\", \"补：理论对话\"))}\n  {#else}\n    将提纲或短段扩展为完整学术段落，层次清楚，证据处标注待核实。\n  {#endif}\n</instructions>\n\n{#if input(\"Length\")}\n  <targetWordCount>\n    {#if input(\"Length\") is \"Double\"}\n      扩写至约原文 2 倍，目标约 {multiply(wordCount(message), 2)} 字。\n    {#elseif input(\"Length\") is \"Triple\"}\n      扩写至约原文 3 倍，目标约 {multiply(wordCount(message), 3)} 字。\n    {#else}\n      {input(\"Length\")}\n    {#endif}\n  </targetWordCount>\n{#endif}\n\n按论证单元分段（论点—证据—解释）。只输出扩写后正文，不要解释。"
        },
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "user",
          "format": "aic2",
          "text": "{include(\"Thesis/Personas\")}\n\n{include(\"Thesis/Codex\")}\n{include(\"Thesis/AdditionalContext\")}\n\n{pov}\n\n{#if either(hasTextAfter, hasTextBefore)}\n  上下文仅供衔接，不要重复：\n  {#if hasTextBefore}\n    <textBefore>\n    {wordsBefore(200)}\n    </textBefore>\n  {#endif}\n  {#if hasTextAfter}\n    <textAfter>\n    {wordsAfter(200)}\n    </textAfter>\n  {#endif}\n{#endif}\n\n待处理文本：\n<text words=\"{wordCount(message)}\">\n{message}\n</text>"
        }
      ]
    },
    "inputs": {
      "2upUvzAvsu8vt19FpteqFmVCF7o": {
        "id": "2upUvzAvsu8vt19FpteqFmVCF7o",
        "name": "Instructions",
        "description": "如何扩写？",
        "required": false,
        "mode": "multiple",
        "types": [
          "dropdown",
          "text"
        ],
        "addToContext": false,
        "hideInput": false,
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2upUw26XeYkjmYqQaGR9xRkQgf9",
                "label": "补：管理启示",
                "color": undefined
              },
              {
                "id": "2upUvz1nwbGV4cwqXW4IpjEzWkP",
                "label": "补：理论对话",
                "color": undefined
              },
              {
                "id": "2upUvz0NDaTdaM7zTY5JreV4EBa",
                "label": "补：证据细节",
                "color": undefined
              }
            ]
          },
          "text": {
            "placeholder": "例：补充案例背景与指标定义",
            "richText": true
          }
        }
      },
      "2upUznWjPInwjOnUSUsrUleyVUo": {
        "id": "2upUznWjPInwjOnUSUsrUleyVUo",
        "name": "Length",
        "description": "扩写到多长？",
        "required": false,
        "mode": "single",
        "types": [
          "dropdown",
          "text"
        ],
        "addToContext": false,
        "hideInput": false,
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2upUzo7yLTRNkFcCMAuevCdDWKF",
                "label": "Double",
                "color": undefined
              },
              {
                "id": "2upUzk80E574QGIMYVlXKUGjYDG",
                "label": "Triple",
                "color": undefined
              }
            ]
          },
          "text": {
            "placeholder": "例：800 字"
          }
        }
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2VqlhPgShWLT9E13hOUKxUidY6y",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "改写",
      "type": PromptType.ManuscriptReplacement,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "你是 MBA 论文学术编辑。\n\n按 instructions 改写给定文本：保持原意与证据口径，提升学术书面语与术语精度。使用 {novel.language}。\n<instructions>{input('Instructions')}</instructions>\n\n只输出改写后正文，不要解释。"
        },
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "user",
          "format": "aic2",
          "text": "{include(\"Thesis/Personas\")}\n\n{include(\"Thesis/Codex\")}\n{include(\"Thesis/AdditionalContext\")}\n\n{pov}\n\n{#if either(hasTextAfter, hasTextBefore)}\n  上下文仅供衔接，不要重复：\n  {#if hasTextBefore}\n    <textBefore>\n    {wordsBefore(200)}\n    </textBefore>\n  {#endif}\n  {#if hasTextAfter}\n    <textAfter>\n    {wordsAfter(200)}\n    </textAfter>\n  {#endif}\n{#endif}\n\n待处理文本：\n<text words=\"{wordCount(message)}\">\n{message}\n</text>"
        }
      ]
    },
    "inputs": {
      "instructions": {
        "id": "instructions",
        "name": "Instructions",
        "description": "如何改写？",
        "required": true,
        "mode": "single",
        "types": [
          "dropdown",
          "text"
        ],
        "addToContext": false,
        "hideInput": false,
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2upRfs3Xoo69vqtPjs1nxp1Av5I",
                "label": "加强论证层次",
                "color": undefined
              },
              {
                "id": "2upRfxHYpKyoK2pIDo9YDSBhVm8",
                "label": "改为学术书面语",
                "color": undefined
              },
              {
                "id": "2upRfrE1CHNnmp6U3PmEUvsTI2c",
                "label": "被动改主动",
                "color": undefined
              },
              {
                "id": "2upRfvpt2LhREF7tPdEZNPC7ppW",
                "label": "换更精确术语",
                "color": undefined
              },
              {
                "id": "2upRfvlJgYXzMfdNzuloLVjkqdp",
                "label": "统一人称表述",
                "color": undefined
              },
              {
                "id": "2upRft6GskGUfrmIkFDHJlsOAjg",
                "label": "客观第三人称",
                "color": undefined
              },
              {
                "id": "2upRfxxsZ4fQZeNApSyR5eMAJoJ",
                "label": "统一时态",
                "color": undefined
              },
              {
                "id": "2upRiNFCjmAf109Jrl9qAQOePs2",
                "label": "用一般现在时陈述规律",
                "color": undefined
              },
              {
                "id": "2upRiSyi7C0XOBuahOZAlaxlVKK",
                "label": "用证据支撑论点",
                "color": undefined
              }
            ]
          },
          "text": {
            "placeholder": "例：更学术、更紧扣研究问题",
            "richText": true
          }
        }
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2Vqlkz6esCcZev5XCxN6hzjCooF",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "缩写",
      "type": PromptType.ManuscriptReplacement,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "你是 MBA 论文学术编辑，负责压缩表述。\n\n在不丢失关键论点与证据的前提下压缩篇幅；保持学术书面语与术语一致。使用 {novel.language}。\n\n{#if input(\"Length\") is \"Half\"}\n  压缩至约一半，目标约 {round(divide(wordCount(message), 2))} 字，勿超出。\n{#elseif input(\"Length\") is \"Quarter\"}\n  压缩至约四分之一，目标约 {round(divide(wordCount(message), 4))} 字，勿超出。\n{#elseif input(\"Length\") is \"Single paragraph\"}\n  压缩为一段连贯学术表述，保留核心论点与关键证据。\n{#else}\n  压缩至：<instructions>{input(\"Length\")}</instructions>\n{#endif}\n\n{include(\"Thesis/AdditionalInstructions\")}\n\n只输出压缩后正文，不要解释。"
        },
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "user",
          "format": "aic2",
          "text": "{include(\"Thesis/Personas\")}\n\n{pov}\n\n{#if either(hasTextAfter, hasTextBefore)}\n  上下文仅供衔接，不要重复：\n  {#if hasTextBefore}\n    <textBefore>\n    {wordsBefore(200)}\n    </textBefore>\n  {#endif}\n  {#if hasTextAfter}\n    <textAfter>\n    {wordsAfter(200)}\n    </textAfter>\n  {#endif}\n{#endif}\n\n待压缩文本：\n<text words=\"{wordCount(message)}\">\n{message}\n</text>"
        }
      ]
    },
    "inputs": {
      "length": {
        "id": "length",
        "name": "Length",
        "description": "How long should the shortened text be?",
        "required": true,
        "mode": "single",
        "types": [
          "dropdown",
          "text"
        ],
        "addToContext": false,
        "hideInput": false,
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2wbbrnYrIu0DGdKUayhTeildKhl",
                "label": "Half",
                "color": undefined
              },
              {
                "id": "2wbbrrR2uGR2IDkkPYGhnCDhgFF",
                "label": "Quarter",
                "color": undefined
              },
              {
                "id": "2wbbrmExBIk9SUJMlWmP07O0VFj",
                "label": "Single paragraph",
                "color": undefined
              }
            ]
          },
          "text": {
            "placeholder": "e.g. 100 words"
          }
        }
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2uzHZscNYOSGrUTGN8VoLDPJW4O",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "论证编审",
      "type": PromptType.WorkshopChat,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "你是 MBA 学位论文论证编审顾问（不是代写枪手）。\n学生就「{either(input(\"Feedback\"), \"综合编审\")}」征求意见；领域/方法偏好：{either(input(\"Genre\"), \"工商管理\")}。\n\n先读材料，再给可执行建议（中文 Markdown）：\n\n<generalAdvice>\n{#if input(\"Feedback\") is \"Developmental\"}\n  开题与论证基础：实践痛点、研究问题可操作性、理论镜头匹配、贡献主张是否可检验。\n{#endif}\n{#if input(\"Feedback\") is \"Structural\"}\n  结构与章节职责：六章分工、章内小节是否服务「问题—框架—证据—启示」、前后章衔接。\n{#endif}\n{#if input(\"Feedback\") is \"Pacing\"}\n  篇幅与节奏：何处空泛需补证，何处冗长可压缩。\n{#endif}\n{#if input(\"Feedback\") is \"Dialogue\"}\n  表述与学术规范：术语一致性、口语/空话、引用与数据待核实标注。\n{#endif}\n{#if input(\"Feedback\") is \"Characterization\"}\n  案例/对象刻画：分析单位与案例边界、关键组织角色是否服务研究问题。\n{#endif}\n</generalAdvice>\n\n输出：1) 总评 2) 对齐开题处 3) 跑偏/缺口 4) 修改清单。不要重写全文。\n\n{include(\"Thesis/Chat/DefaultContext\")}\n{include(\"Thesis/Chat/DefaultInstructions\")}"
        }
      ]
    },
    "inputs": {
      "2uzHzkB0MRoUyYrWDkcEH4fsi1d": {
        "id": "2uzHzkB0MRoUyYrWDkcEH4fsi1d",
        "mode": "single",
        "name": "Genre",
        "description": "This will determine the genre that your AI assistant specialises in.",
        "required": true,
        "types": [
          "text",
          "dropdown"
        ],
        "addToContext": false,
        "hideInput": false,
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2uzIFJmq6AQ2oF3GmPegNDPvRrQ",
                "label": "Cozy: Fantasy",
                "color": "yellow"
              },
              {
                "id": "2uzIFKoaXR6ysNKRnlgsj39kPUk",
                "label": "Cozy: Mystery",
                "color": "yellow"
              },
              {
                "id": "2uzIFLNvSdQ3iICLrnPWlUEHx0L",
                "label": "Cozy: Romance",
                "color": "yellow"
              },
              {
                "id": "2uzIFMHdrpJCXeWIVVgZ5kx53jA",
                "label": "Fantasy: Dark",
                "color": "green"
              },
              {
                "id": "2uzIFLuVp1ecKyvRGy2Z9iEC2gi",
                "label": "Fantasy: Epic/High",
                "color": "green"
              },
              {
                "id": "2uzIFJqClvzPpz6sw5s4GJ3rn7Q",
                "label": "Fantasy: Paranormal",
                "color": "green"
              },
              {
                "id": "2uzIFJ9NXzzKB2wlPWFR3IN8XfS",
                "label": "Fantasy: Urban",
                "color": "green"
              },
              {
                "id": "2uzIFHHpn0MFe5N1bOUvbSlOs0x",
                "label": "Horror: Psychological",
                "color": "gray"
              },
              {
                "id": "2uzIFEhDUFbjrJVPQZTYZ5oeDTp",
                "label": "Horror: Supernatural",
                "color": "gray"
              },
              {
                "id": "2uzIFHssmOuqFt7Xs7Q6pg6XrXz",
                "label": "Romance: Billionaire",
                "color": "red"
              },
              {
                "id": "2uzIIsPfEy6YTpJCXB8jaZcCRF2",
                "label": "Romance: Enemies to Lovers",
                "color": "red"
              },
              {
                "id": "2uzIIoqV9JUbbAevpWWAoXpaqQd",
                "label": "Romance: Erotic",
                "color": "red"
              },
              {
                "id": "2uzIIoiA86pMOET8HdOheu29Lp0",
                "label": "Romance: Paranormal",
                "color": "red"
              },
              {
                "id": "2uzIIo5Y9UEsiCWMI57enwTWhWw",
                "label": "Romance: Second Chance",
                "color": "red"
              },
              {
                "id": "2uzIIqh7lFP0UuuAEFAVg6JRy9I",
                "label": "Romance: Sweet/Clean",
                "color": "red"
              },
              {
                "id": "2uzIIs7AypjETPYCcc9xVYKOl1r",
                "label": "Romance: Uniform",
                "color": "red"
              },
              {
                "id": "2uzIIoZAQYgg30K9evFWz8LKxNf",
                "label": "Sci-Fi: Dystopian",
                "color": "blue"
              },
              {
                "id": "2uzIInhsNVSyShOl1jxXdSwrpDV",
                "label": "Sci-Fi: Space Opera",
                "color": "blue"
              },
              {
                "id": "2uzIIpkm22wisWCveUuXyG4PXZ8",
                "label": "Sci-Fi: Steampunk",
                "color": "blue"
              }
            ]
          }
        }
      },
      "2uzIIqRIQ1Cxh49ZXLa6Cnp20E6": {
        "id": "2uzIIqRIQ1Cxh49ZXLa6Cnp20E6",
        "mode": "single",
        "addToContext": false,
        "hideInput": false,
        "name": "Feedback",
        "description": "What kind of feedback do you want from the AI?",
        "required": false,
        "types": [
          "dropdown"
        ],
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "2uzITqmMnoDmT43To3BATKbVvgy",
                "label": "Pacing",
                "color": "gray"
              },
              {
                "id": "2uzITt0yfv6lQQ8eRORq5Wt8I2f",
                "label": "Dialogue",
                "color": "pink"
              },
              {
                "id": "2uzITovUBIDJwWD5YjcwHCmAHe6",
                "label": "Characterization",
                "color": "blue"
              },
              {
                "id": "2uzITqdtkwPKd3bRZBje5rGu7S8",
                "label": "Structural",
                "color": "green"
              },
              {
                "id": "2uzITsLY6GoF9ID5aFhKOTK0g8e",
                "label": "Developmental",
                "color": "yellow"
              }
            ]
          }
        }
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2Vqnjv9xWUusg26Zg45zUdPb0ly",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "开题助手",
      "type": PromptType.WorkshopChat,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "你是论文台「开题助手」，帮助学生收窄研究问题、对齐开题卡、规划六章论证。不是代写枪手。\n\n今天是 {date.today}；当前论文题目：「{novel.title}」。\n\n可以回答：研究问题如何收窄、某章该写什么、方法是否匹配、如何修订开题卡。不要编造文献或数据。\n\n{include(\"Thesis/Chat/DefaultContext\")}\n{include(\"Thesis/Chat/DefaultInstructions\")}"
        }
      ]
    },
    "inputs": {},
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_2Wko6EPDgoK020EjUuns9OffiNu",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "小节提纲",
      "type": PromptType.WorkshopChat,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "你是 MBA 论文目录/小节提纲助手。\n\n根据给定的章/节摘要，列出 {input(\"amount\")} 条可执行的小节写作要点（不是小说节拍）。\n\n要求：具体、可写进正文；逻辑连贯；不超出摘要、不抢写后章；每条对应一个论证动作。\n\n输出格式：\n1. 要点…\n2. …\n\n{#if input(\"Scene\")}\n当前节摘要：\n{input(\"Scene\")}\n{#endif}\n\n{include(\"Thesis/Chat/DefaultContext\")}\n{include(\"Thesis/Chat/DefaultInstructions\")}"
        }
      ]
    },
    "inputs": {
      "2ws9cGfUuCgmFJY2wB5IFvimB9i": {
        "id": "2ws9cGfUuCgmFJY2wB5IFvimB9i",
        "name": "Scene",
        "description": "The scene we want to develop the beats for.",
        "mode": "single",
        "required": true,
        "types": [
          "scene"
        ],
        "addToContext": true,
        "hideInput": false,
        "settings": {
          "scene": {
            "mode": "outline"
          }
        }
      },
      "2ws9cGIqoHIrIeQpSIeyktMHsSI": {
        "id": "2ws9cGIqoHIrIeQpSIeyktMHsSI",
        "name": "Amount",
        "description": "How many beats should be generated?",
        "mode": "single",
        "addToContext": true,
        "hideInput": true,
        "types": [
          "dropdown",
          "text"
        ],
        "required": true,
        "default": [
          {
            "type": "dropdown",
            "value": "2ws9cH2oVfEsN6RDoVtrrEQSFnZ"
          }
        ],
        "settings": {
          "text": {
            "placeholder": "e.g. 10"
          },
          "dropdown": {
            "options": [
              {
                "id": "2ws9cCoysd7ZBZpDfIhWbJlskTS",
                "label": "6",
                "color": undefined
              },
              {
                "id": "2ws9cI2gRmhCw969V8BRLKZVdMf",
                "label": "8",
                "color": undefined
              },
              {
                "id": "2ws9cH2oVfEsN6RDoVtrrEQSFnZ",
                "label": "12",
                "color": undefined
              }
            ]
          }
        }
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_nc_additionalContext",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "name": "Thesis/AdditionalContext",
      "type": PromptType.Component,
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{! 避免与资料库重复注入 !}\n{local('context', without(input(\"Additional Context\"), codex.context))}\n\n{#if local('context')}\n补充上下文：\n<additionalContext>\n{asXml(local('context'))}\n</additionalContext>\n{#endif}"
        }
      ]
    },
    "inputs": {
      "2upJSdYH2r4ToLltr1Aby5BtY50": {
        "id": "2upJSdYH2r4ToLltr1Aby5BtY50",
        "name": "Additional Context",
        "description": "额外注入的上下文（章/节/资料）",
        "mode": "multiple",
        "required": false,
        "addToContext": true,
        "displayName": "上下文",
        "hideInput": false,
        "types": [
          "act",
          "chapter",
          "scene",
          "snippet",
          "codex",
          "fullNovel"
        ]
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_nc_additionalInstructions",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "type": PromptType.Component,
      "name": "Thesis/AdditionalInstructions",
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{#if input(\"Instructions\")}\n额外指令（请严格遵循）：\n<instructions>\n{input(\"Instructions\")}\n</instructions>\n{#endif}"
        }
      ]
    },
    "inputs": {
      "2vMoijtg7PMzestIWomrTMWoCAO": {
        "id": "2vMoijtg7PMzestIWomrTMWoCAO",
        "name": "Instructions",
        "description": "可选：补充角色或约束",
        "mode": "single",
        "required": false,
        "addToContext": false,
        "hideInput": true,
        "types": [
          "text"
        ],
        "settings": {
          "text": {
            "placeholder": "例：你是 MBA 论文方法顾问…",
            "richText": true
          }
        }
      }
    },
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_nc_chat_defaultInstructions",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "type": PromptType.Component,
      "name": "Thesis/Chat/DefaultInstructions",
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{! 开题助手默认输出规范 !}\n用 Markdown 回答，不要用 HTML。\n使用 {novel.language} 的拼写与语法习惯。\n涉及事实与文献时提醒学生自行核实。"
        }
      ]
    },
    "inputs": {},
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_nc_chat_defaultContext",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "type": PromptType.Component,
      "name": "Thesis/Chat/DefaultContext",
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{include(\"Thesis/SeriesContext\")}\n{include(\"Thesis/Personas\")}\n{include(\"Thesis/AdditionalInstructions\")}\n{include(\"Thesis/Codex\")}\n{include(\"Thesis/AdditionalContext\")}"
        }
      ]
    },
    "inputs": {},
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_nc_codex_default",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "type": PromptType.Component,
      "name": "Thesis/Codex",
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{#if codex.context}\n撰写时参考下列资料库（概念/场域/理论/工具/案例线索），保持术语一致：\n<codex>\n{codex.context}\n</codex>\n{#endif}"
        }
      ]
    },
    "inputs": {},
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "sys_nc_seriesInfo",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "type": PromptType.Component,
      "name": "Thesis/SeriesContext",
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{#if novel.hasSeries}\n当前论文属于专题/系列「{series.title}」。\n{#if series.description}\n专题说明：\n<seriesDescription>\n{content(series.description)}\n</seriesDescription>\n{#endif}\n{#endif}"
        }
      ]
    },
    "inputs": {},
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    },
  },
  {
    "id": "sys_nc_personas",
    type: CoreEntityType.Prompts,
    meta: {
      state: "active",
      createdAt: new Date(2025, 3, 13, 0, 0, 0).toISOString(),
      updatedAt: new Date(2025, 3, 13, 0, 0, 0).toISOString()
    },
    "attributes": {
      "type": PromptType.Component,
      "name": "Thesis/Personas",
      "models": [],
      "messages": [
        {
          "id": "2upJScvI4yYwTjSO5aZZDYRH8I5",
          "type": "system",
          "format": "aic2",
          "text": "{#if personas}\n学生偏好（写作时参考语气与约束，勿写成小说角色）：\n<personas>\n{personas}\n</personas>\n{#endif}"
        }
      ]
    },
    "inputs": {},
    relationships: {
      owner: {
        type: "users",
        id: "system"
      }
    }
  },
  {
    "id": "31e7wiUmSxBvVkBzaRsuMrgMshJ",
    type: CoreEntityType.Prompts,
    "meta": {
      "state": "active",
      "createdAt": "2025-08-22T14:28:44.677Z",
      "updatedAt": "2025-08-22T14:57:16.209Z"
    },
    "attributes": {
      "type": PromptType.Other,
      "name": "通用续写（备用）",
      "nsfw": false,
      "messages": [
        {
          "id": "31UJVG9rHV2PzzZGQkzkWWZMrFr",
          "type": "system",
          "text": "你是 MBA 论文写作助手。\n- 使用 {novel.language} 学术书面语。\n- 服从开题卡与本章任务，不编造证据。\n\n{include(\"Thesis/AdditionalInstructions\")}",
          "format": "aic2",
        },
        {
          "id": "31UJVK2XX8xRiXE0RdJxTQaQ82A",
          "type": "user",
          "text": "{include(\"Thesis/Personas\")}\n{include(\"Thesis/Codex\")}\n{#if storySoFar}\n前文摘要：\n{storySoFar}\n{#endif}",
          "format": "aic2",
        },
        {
          "id": "31UJVH2agusfyR8i0cn2diXaE1d",
          "type": "assistant",
          "text": "{textBefore()}",
          "format": "aic2",
        },
        {
          "type": "user",
          "text": "<instructions>\n  {pov}\n  {message}\n</instructions>\n{input(\"New input\")}\n{include(\"Thesis/AdditionalContext\")}",
          "format": "aic2",
          "id": "31UJVEqkI6NcIIRVo2fBt73qV0O"
        }
      ],
      "models": [
        {
          "internalId": "31e8JP0EHyJYHHlyScX007dI7M2",
          "id": "deepseek-chat",
          "name": "Deepseek Chat",
          "group": "kk",
          "temperature": 0.1
        }
      ],
      "description": "<p>这是一个test new other</p>"
    },
    "inputs": {
      "31e8dfZTtDGUgHnhxxVuwDX9MFx": {
        "id": "31e8dfZTtDGUgHnhxxVuwDX9MFx",
        "name": "New input",
        "description": "",
        "required": false,
        "mode": "multiple",
        "types": [
          "dropdown",
          "text"
        ],
        "addToContext": false,
        "hideInput": false,
        "displayName": undefined,
        "default": [
          {
            "type": "dropdown",
            "value": "31e9HzLAxyItM8nwRG9fpL8iW7T"
          },
          {
            "type": "dropdown",
            "value": "31e9UBF4JG3F0Ox6lY38EWc5ZbR"
          },
          {
            "type": "text",
            "value": "<nc-xml name=\"div\"><p>efsd af</p></nc-xml>"
          }
        ],
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "31e9HzLAxyItM8nwRG9fpL8iW7T",
                "label": "a",
                "color": undefined,
                "description": "abc",
                "value": "<p>abc abc</p>"
              },
              {
                "id": "31e9UBF4JG3F0Ox6lY38EWc5ZbR",
                "label": "b",
                "color": undefined
              }
            ]
          },
          "text": {
            "placeholder": "test text",
            "richText": true
          }
        }
      },
      "31eAn4ShT4RewyMzDV2FLJlp2lC": {
        "id": "31eAn4ShT4RewyMzDV2FLJlp2lC",
        "name": "New input",
        "description": "",
        "required": true,
        "mode": "multiple",
        "types": [
          "act",
          "chapter",
          "codex",
          "fullNovel",
          "label",
          "scene",
          "snippet"
        ],
        "addToContext": false,
        "hideInput": true,
        "displayName": "dsfsfsa",
        "default": [],
        "settings": {
          "codex": {
            "types": [
              "character",
              "location",
              "lore",
              "object",
              "other",
              "subplot"
            ]
          },
          "chapter": {
            "mode": "outline"
          },
          "scene": {
            "mode": "outline"
          }
        }
      },
      "31eBMpZ9jJSiQUrINk5s0cOVlPX": {
        "id": "31eBMpZ9jJSiQUrINk5s0cOVlPX",
        "name": "New input",
        "description": "",
        "required": false,
        "mode": "single",
        "types": [
          "checkbox"
        ],
        "addToContext": false,
        "hideInput": false,
        "displayName": "New input",
        "default": [
        ],
        "settings": undefined
      }
    },
    "relationships": {
      "owner": {
        "id": "user_31DJe07dLKK0ZwPoepTqzDPvQ39",
        "type": "users"
      }
    }
  },
  {
    "id": "30HPdNOOvcIQx2QN2A7nev3vc8H",
    "type": CoreEntityType.Prompts,
    "meta": {
      "state": "active",
      "createdAt": "2025-07-23T14:40:11.267Z",
      "updatedAt": "2025-07-23T15:33:21.896Z"
    },
    "attributes": {
      "type": PromptType.ManuscriptReplacement,
      "name": "学术改写（备用）",
      "nsfw": false,
      "messages": [
        {
          "type": "system",
          "text": "你是 MBA 论文学术编辑。\n\n{include(\"Thesis/AdditionalInstructions\")}\n\n只输出编辑后的正文，不要解释。",
          "format": "aic2",
          "id": "30HPdMINHTNJDo7SEe9ECdx6an9"
        },
        {
          "type": "user",
          "text": "{include(\"Thesis/Personas\")}\n\n{pov}\n\n{#if either(hasTextAfter, hasTextBefore)}\n  上下文仅供衔接，不要重复：\n  {#if hasTextBefore}\n    <textBefore>\n    {wordsBefore(200)}\n    </textBefore>\n  {#endif}\n  {#if hasTextAfter}\n    <textAfter>\n    {wordsAfter(200)}\n    </textAfter>\n  {#endif}\n{#endif}\n\n待改写文本：\n<text words=\"{wordCount(message)}\">\n{message}\n</text>\n{input(\"Geng\")}",
          "format": "aic2",
          "id": "30HPdPT3aqoM08c0WZcGlX1fZsw"
        }
      ],
      "models": [
        {
          "internalId": "30HPtS58OpkRydexHDk95HAgzPx",
          "id": "",
          "name": ""
        }
      ],
      "description": undefined
    },
    "inputs": {
      "30HPeR2F0PeRBfPfA5GdAT3QhPo": {
        "id": "30HPeR2F0PeRBfPfA5GdAT3QhPo",
        "name": "Geng",
        "description": "",
        "required": true,
        "mode": "multiple",
        "types": [
          "dropdown",
          "text"
        ],
        "addToContext": false,
        "hideInput": true,
        "displayName": undefined,
        "default": [
          {
            "type": "text",
            "value": "abcd"
          },
          {
            "type": "dropdown",
            "value": "30HRstyU4qLr82Hd4wacCTd18PM"
          }
        ],
        "settings": {
          "dropdown": {
            "options": [
              {
                "id": "30HRstyU4qLr82Hd4wacCTd18PM",
                "label": "gg",
                "color": "red"
              },
              {
                "id": "30HRt9PdrhsmndmRcgMIXtlqNwS",
                "label": "jjj",
                "color": "yellow"
              }
            ]
          }
        }
      }
    },
    "relationships": {
      "owner": {
        "id": "user_30EbWOl1QqDvn9wVbufNwCJzFdE",
        "type": "users"
      }
    }
  }
]

export default prompts